import React, { useMemo } from "react"
import CustomTable from "components/Table/CustomTable"
import dayjs from "dayjs"
import { Badge } from "reactstrap"
import { LogsSchema } from "model/profile/logs.schema"

// Custom Hooks
import useTableChangeHandler from "hooks/useTableChangeHandler"

const LogsTable = ({ data, onTableChange, isLoading, error }) => {
  // HOOK CHANGE
  const { handleSort, handleFilter, handleSearch, handlePageChange } =
    useTableChangeHandler(onTableChange)

  const columns = useMemo(
    () => [
      {
        header: "หมวดหมู่",
        accessor: "module",
        sortable: true,
        render: item => (
          <div className="text-success-500 fw-semibold">{item.module}</div>
        ),
      },
      {
        header: "การกระทำ",
        accessor: "action",
        sortable: true,
        align: "center",
        render: item => {
          const getBadgeColor = action => {
            switch (action) {
              case "สร้าง":
                return "success"
              case "แก้ไข":
                return "info"
              case "ลบ":
                return "danger"
              default:
                return "secondary"
            }
          }

          return (
            <div className="flex justify-content-center">
              <Badge color={getBadgeColor(item.action)}>{item.action}</Badge>
            </div>
          )
        },
      },
      {
        header: "รายละเอียด",
        accessor: "description",
        render: item => <div className="text-gray-700">{item.description}</div>,
      },
      {
        header: "เวลา",
        accessor: "timestamp",
        sortable: true,
        render: item => (
          <div className="text-gray-500">
            {dayjs(item.timestamp).format("DD/MM/YYYY HH:mm")}
          </div>
        ),
      },
    ],
    []
  )

  return (
    <div>
      <div className="text-lg mb-4">
        ประวัติการใช้งาน ในระบบทั้งหมด *{data?.pagination?.total?.toLocaleString() || 0}{" "}
        รายการ *
      </div>
      <CustomTable
        data={data?.data || []}
        columns={columns}
        itemsPerPage={data?.pagination?.limit || 10}
        totalItems={data?.pagination?.total || 0}
        onSort={handleSort}
        onFilter={handleFilter}
        onSearch={handleSearch}
        onPageChange={handlePageChange}
        status={
          isLoading
            ? "loading"
            : error
            ? "error"
            : data?.data?.length === 0
            ? "empty"
            : "normal"
        }
        errorMessage={error?.message || "เกิดข้อผิดพลาดในการโหลดข้อมูล"}
        emptyMessage="ไม่พบประวัติการใช้งาน"
      />
    </div>
  )
}

const withYupValidation = (WrappedComponent, schema) => {
  return function WithYupValidation(props) {
    // Skip validation if loading or error
    if (props.isLoading || props.error) {
      return <WrappedComponent {...props} />
    }
    
    try {
      schema.validateSync(props.data)
      return <WrappedComponent {...props} />
    } catch (error) {
      return (
        <div className="alert alert-danger">
          <strong>Validation Error:</strong> {error.message}
        </div>
      )
    }
  }
}

const ValidatedTable = withYupValidation(LogsTable, LogsSchema)

export default ValidatedTable
